const React = require('react');

/**
 * simple version of range slider v2 ...
 *
 * limitations:
 * only supports one knubbel
 * only supports horizontal sliders
 * only supports linear scaling
 * bars are always shown (use css!)
 * slightly different interface
 *
 */
class RangeSlider extends React.Component {
    constructor(props) {
        super(props);

        this.onRailClick = this.onRailClick.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        this.state = {
            percent: this.getPercentFromValue(this.props.value)
        };

        this.dragging = false;
        this.lastClientX = 0;
    }

    componentWillUnmount(){
        this.removeMoveListeners()
    }

    onRailClick(e) {
        this.handleRelease(e);
    }

    componentWillReceiveProps(props) {
        this.setState({
            percent: this.getPercentFromValue(props.value)
        });
    }

    /**
     * when the user has set a new value, this function is called and the this.props.onRelease handler is called if supplied
     * @param e
     */
    handleRelease(e) {
        let percent = this.getPercentFromEvent(e);
        this.setState({
            percent: percent
        });
        if (this.props.onRelease) {
            this.props.onRelease([this.getValueFromPercent(percent)]);
        }
    }

    /**
     * it may improve performance to attach and remove these eventlisteners on the fly
     */
    attachMoveListeners(){
        document.addEventListener('mouseup', this.onDragEnd, false);
        document.addEventListener('touchend', this.onDragEnd, false);
        document.addEventListener('touchmove', this.onDrag, false);
        document.addEventListener('mousemove', this.onDrag, false);
    }

    /**
     * it may improve performance to attach and remove these eventlisteners on the fly
     */
    removeMoveListeners(){
        document.removeEventListener('mouseup', this.onDragEnd);
        document.removeEventListener('touchend', this.onDragEnd);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mousemove', this.onDrag);
    }

    onDragStart(e) {
        this.dragging = true;
        this.attachMoveListeners();
        this.handleChange(e);
    }

    /**
     * when the user is dragging the slider
     * @param e
     */
    handleChange(e) {
        let percent = this.getPercentFromEvent(e);
        this.setState({
            percent: percent
        });
        if (this.props.onChange) {
            this.props.onChange(this.getValueFromPercent(percent));
        }
    }

    onDrag(e) {
        if(!this.dragging){
            return;
        }

        this.handleChange(e);
    }

    onDragEnd(e) {
        if(!this.dragging){
            return;
        }
        this.dragging = false;
        this.removeMoveListeners();
        this.handleRelease(e);
    }

    getPercentFromValue(value) {
        let rawPercent = this.getRawPercentFromValue(value);

        return this.snapPercent(this.clampPercent(rawPercent));
    }

    getRawPercentFromValue(value) {
        return (value - this.props.range[0]) / this.getRange() * 100;
    }

    getValueFromPercent(percent) {
        return percent / 100 * this.getRange() + this.props.range[0];
    }

    /**
     * return the range ov values (max - min)
     * @returns {number}
     */
    getRange() {
        return this.props.range[1] - this.props.range[0];
    }

    /**
     *
     * @param e
     * @returns {number}
     */
    getPercentFromEvent(e) {
        let rawPercent = this.getLeftOffsetFromEvent(e) / this.getParentWidth() * 100;

        return this.snapPercent(this.clampPercent(rawPercent));
    }

    /**
     * always return a value between 0 and 100
     * @param percent
     * @returns {number}
     */
    clampPercent(percent){
        return Math.min(Math.max(percent, 0),100);
    }

    /**
     * snaps a percent value to the next point (as defined by this.props.points)
     * @param percent
     * @returns {*}
     */
    snapPercent(percent){
        if(!this.props.points){
            return percent;
        }
        let value = this.getValueFromPercent(percent);

        // copy array dont change it
        let snappedValue = [].concat(this.props.points)
            .sort((a, b) => {
                return Math.abs(a - value) - Math.abs(b - value);
            })
            .shift();

        // use rawValue, otherwise this is an infinite loop!
        // guaranteed to be valid
        return this.getRawPercentFromValue(snappedValue);
    }

    render() {
        return (
            <div
                className="rangeslider v3 horizontal"
                ref="parent"
                onClick={this.onRailClick}
            >
                <div className="rangeslider-rail">
                    <div
                        className="rangeslider-bar"
                        style={{
                            width: this.state.percent + '%'
                        }}
                    />
                </div>
                <div
                    className="rangeslider-handle"
                    onMouseDown={this.onDragStart}
                    onTouchStart={this.onDragStart}
                    style={{
                        left: this.state.percent + '%'
                    }}
                />
            </div>
        )
    }

    getParentWidth() {
        let rect = this.refs.parent.getBoundingClientRect();
        return rect.right - rect.left;
    }

    getLeftOffsetFromEvent(e) {
        let rect = this.refs.parent.getBoundingClientRect();
        let clientX = e.clientX;
        if (typeof e.touches == 'object') {
            /* required for tablets. Issue found at least on iPad, Galaxy S4.
               in case of touchend touches (and clientX) is not available (on all browsers) */
            clientX = this.lastClientX;
            if (e.type !== 'touchend') {
                //affect touchstart, touchmove
                clientX = e.touches[0].clientX;
                this.lastClientX = clientX;
            }
        }
        return clientX - rect.left;
    }
}

export default RangeSlider;



// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/RangeSliderv3.jsx